import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'AgencyAnalytics Case Study | Canny';
const Description =
  'Read about how AgencyAnalytics uses Canny to earn more revenue and avoid churn.';
const Image = 'https://canny.io/images/50b715416e612f52cf5735ff6f79f2a2.jpg';

export default class AgencyAnalyticsLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },
          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/agencyanalytics' },
          { property: 'og:type', content: 'website' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
